import { Injectable } from '@angular/core';

import Compressor from 'compressorjs';
import { BigQueryLoggingService } from 'src/app/components/logging/big-query-logging.service';

@Injectable({
  providedIn: 'root',
})
export class CompressorJsService {
  get(domFileItem, options: Compressor.Options): Compressor {
    return new Compressor(domFileItem, options);
  }
}

@Injectable({
  providedIn: 'root',
})
export class JpegCompressorService {
  disabled = false;

  constructor(
    private bigQueryLoggingService: BigQueryLoggingService,
    private compressorJsService: CompressorJsService,
  ) {}

  compress(fileItem, folderPath) {
    return new Promise((resolve) => {
      if (this.disabled || fileItem.file.type !== 'image/jpeg') {
        return resolve(true);
      }

      this.compressorJsService.get(fileItem.domFileItem, {
        quality: 0.7,
        checkOrientation: true,
        retainExif: true,
        success: (result) => {
          this.bigQueryLoggingService.logEvent(
            'image compressed',
            folderPath + fileItem.file.name,
            result.size / fileItem.file.size,
          );

          fileItem.domFileItem = result;
          fileItem.file.size = result.size;
          resolve(true);
        },
        error: (err) => {
          console.debug(err);
          this.bigQueryLoggingService.logEvent(
            'image compress error',
            folderPath + fileItem.file.name + ' | ' + err.message,
          );
          this.disabled = true;
          resolve(true);
        },
      });
    });
  }
}
